import { render } from "./CollectionTable.vue?vue&type=template&id=3a222ebe&scoped=true"
import script from "./CollectionTable.vue?vue&type=script&lang=js"
export * from "./CollectionTable.vue?vue&type=script&lang=js"

import "./CollectionTable.vue?vue&type=style&index=0&id=3a222ebe&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a222ebe"]])

export default __exports__